import React from "react";
import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "../shared/BaseFragment";
import {StyledBoxColumn} from "../shared/StyledComponents";
import {PathComponent} from "../index";
import {Outlet} from "react-router-dom";
import {COLOR_BG1} from "./App";
import {RoomFragment} from "./RoomFragment";
import {MainFragment} from "./MainFragment";
import {LoginFragment} from "./LoginFragment";

export type MainProps = BaseFragmentProps & {}

type MainState = BaseFragmentState & {}

export class Main extends BaseFragment<MainProps, MainState> {

  static nestedPaths(): PathComponent[] {
    return [
      {
        path: "new",
        render: pathProps => <MainFragment path={pathProps}/>,
      },
      {
        path: "login",
        render: pathProps => <LoginFragment path={pathProps}/>,
      },
      {
        path: "/r/:room_id",
        render: pathProps => <RoomFragment
          path={pathProps}
          roomId={(pathProps.params.room_id as string)?.toUpperCase()}/>,
      },
    ]
  }

  renderContainerContent(): React.ReactElement {
    return <StyledBoxColumn style={{background: COLOR_BG1, flexGrow: 1, gap: 0, position: "relative"}}>
      <Outlet/>
    </StyledBoxColumn>
  }
}
